import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { resultsPerPage } from '@Pages/Results/selectors';
import { setResultsPerPage } from '@Pages/Results/actions';

import { withCombinedInfo } from '@Hooks/withCombinedInfo';
// TODO move user-related stuff from Header to separate actions/selectors/reducer
import { resultsPerPageIELimit } from '@Containers/Header/HeaderComponentSelectors';

import { dropdownValues } from '../ResultsPaginationSelectors';
import { setDropdownValues } from '../ResultsPaginationActions';

import { getResultsPerPageValues as getResultsPerPageValuesHelper } from '../ResultsPaginationHelper';

// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import ResultsPerPage from './ResultsPerPage';

export function ResultsPerPageContainer(props) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return <ResultsPerPage {...props} dropdownOpen={dropdownOpen} setDropdownOpen={setDropdownOpen} />;
}

function mapStateToProps(state) {
  return {
    dropdownValues: dropdownValues(state),
    resultsPerPage: resultsPerPage(state),
    resultsPerPageIELimit: resultsPerPageIELimit(state),
  };
}

const mapDispatchToProps = {
  setDropdownValues,
  setResultsPerPage,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withCombinedInfo({
    loaded: (props, combinedInfo) => {
      const values = getResultsPerPageValuesHelper(combinedInfo, props.resultsPerPageIELimit);
      props.setDropdownValues(values);
    },
  })
)(ResultsPerPageContainer);
